import { motion } from "framer-motion";
import { Instagram, Heart, MessageCircle, Share2, Bookmark } from "lucide-react";

export default function Community() {
  return (
    <section id="community" className="relative overflow-hidden py-24 lg:py-32 scroll-mt-20" data-testid="community-section">
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <span className="absolute -left-24 top-1/2 -translate-y-1/2 font-display font-semibold text-[26rem] leading-none text-[#A9CDE9]/25 rotate-[6deg]">s</span>
        <span className="absolute -right-16 -bottom-24 font-display font-semibold text-[16rem] leading-none text-accent/15 -rotate-[10deg] hidden lg:block">y</span>
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.55 }}
        >
          <p className="font-hand text-2xl text-primary mb-3">join the crew</p>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight mb-6" data-testid="community-heading">
            The digital neighbourhood watch,{" "}
            <span className="text-primary">Calgary edition.</span>
          </h2>
          <p className="text-muted-foreground text-base md:text-lg leading-relaxed mb-4" data-testid="community-copy">
            Every week on Instagram we break down the scams actually hitting Calgary inboxes, share
            two-minute fixes anyone can do, and answer your questions in plain English.
          </p>
          <p className="text-muted-foreground text-base md:text-lg leading-relaxed mb-10">
            Join a growing crew of Calgarians getting cyber-smarter every week — one scroll at a time.
          </p>
          <a
            href="https://www.instagram.com/cybersecyyc/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="community-instagram-button"
            className="inline-flex items-center gap-2.5 bg-foreground text-background font-display font-medium px-8 py-4 rounded-full hover:scale-[1.03] transition-transform duration-200"
          >
            <Instagram className="w-5 h-5" strokeWidth={2} />
            Follow @cybersecyyc
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.55, delay: 0.12 }}
          className="relative max-w-md mx-auto w-full"
        >
          <div className="rounded-3xl overflow-hidden border border-border shadow-sm aspect-[4/5]">
            <img
              src="https://images.unsplash.com/photo-1761790184885-f1122aed0080?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxjYWxnYXJ5JTIwc2t5bGluZSUyMHN1bm55fGVufDB8fHx8MTc4ODIyODU3OXww&ixlib=rb-4.1.0&q=85"
              alt="Calgary skyline at golden hour"
              className="w-full h-full object-cover"
              loading="lazy"
              data-testid="community-image"
            />
          </div>

          <div
            className="absolute -bottom-8 -left-4 sm:-left-10 bg-card border border-border rounded-2xl shadow-md p-5 w-64 rotate-[-3deg]"
            data-testid="community-post-mockup"
          >
            <div className="flex items-center gap-2.5 mb-3">
              <span className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                <Instagram className="w-4 h-4 text-primary-foreground" strokeWidth={2} />
              </span>
              <div>
                <p className="font-display font-medium text-xs">cybersecyyc</p>
                <p className="text-[10px] text-muted-foreground">Calgary, Alberta</p>
              </div>
            </div>
            <p className="text-xs leading-relaxed text-muted-foreground mb-3">
              PSA: that "CRA refund" text going around the 403 today? It's fake. Here's how to tell in 5 seconds...
            </p>
            <div className="flex items-center gap-4 text-foreground">
              <Heart className="w-4 h-4" strokeWidth={1.8} />
              <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
              <Share2 className="w-4 h-4" strokeWidth={1.8} />
              <Bookmark className="w-4 h-4 ml-auto" strokeWidth={1.8} />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
